var map = {
	"./lifestyle.png": 8284,
	"./local.png": 1654,
	"./meetings.png": 8126,
	"./restaurants.png": 4485,
	"./rooftoop.png": 4396,
	"./signature.png": 302,
	"./spa.png": 2960,
	"./story.png": 5445,
	"./sustainability.png": 6666,
	"./terraces.png": 4589,
	"./transfers.png": 4083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5672;